/// <reference path="../../../../../../shared/models/generated/BankOperationsBankOperationReturnConvertApi.d.ts"/>
/// <reference path="../../models/CreditCardCheckResponseModel.d.ts"/>
/// <reference path="../../../../../../shared/models/generated/ZahlungsweisenVerifyHashModelApi.d.ts"/>

import { AppViewService } from '../../services/AppViewService';
import { AppPersistenceService } from '../../services/AppPersistenceService';
import { AppApiService } from '../../services/AppApiService';
import { AppValidationService } from '../../services/AppValidationService';
import { ViewConfiguration } from '../../../../../../shared/services/BasicViewService';
import { AppUtils } from '../../../../../../shared/utils/index';

export class CalculatorController implements StepController, IbanViewEvents, IbanLightBoxEvents {

	private scopes: string[];
	private readonly parent: AppController;
	private readonly options: BasicAppOptions<IbanAppDefinition>;
	private readonly loader: BasicLoader<IbanAppDefinition>;
	private readonly appViewService: AppViewService;
	private readonly appPersistenceService: AppPersistenceService;
	private readonly appApiService: AppApiService;
	private appValidationService: AppValidationService;
	private appValidationServiceLightbox: AppValidationService;
	private readonly $ctx: JQuery;

	constructor(parent: AppController, options: BasicAppOptions<IbanAppDefinition>, loader: BasicLoader<IbanAppDefinition>) {
		this.parent = parent;
		this.options = options;
		this.loader = loader;
		this.$ctx = $(options.$ctx);
		this.appViewService = new AppViewService(options, undefined, loader);
		this.appPersistenceService = new AppPersistenceService(options);
		this.appApiService = new AppApiService(options);
	}

	public start(): void {
		this.scopes = this.getMultiScopeConfig();
		if (!this.scopes.length) {
			this.scopes.push("");
			this.appViewService.render(this.getViewConfigForSingleIban());
		} else {
			//set required to false for multi iban
			this.options.app.validatorRules.rules["Bankdaten.Iban"].required = false;
			this.options.app.validatorRules.rules["Bankdaten.Iban"].oneibanrequired = true;

			// wait till all html snippets are loaded
			let toResolve = this.scopes.length;
			this.scopes.forEach((value) => {
				const viewConfig = this.getViewConfigForMultiIban(value, () => {
					this.appViewService.appendIbanLightBox(value);
					toResolve--;
					if (toResolve <= 0) {
						this.afterRenderApp();
					}
				});
				this.appViewService.render(viewConfig);
			});
		}
	}

	private getViewConfigForSingleIban(): ViewConfiguration<IbanAppDefinition> {
		return {
			data: this.getViewOptions(false, ""),
			templateurl: this.options.app.currenttemplate.templateurl,
			parent: this,
			$ctx: $(`#${this.options.contentid}`),
			options: this.options,
			callback: (): void => {
				this.appViewService.appendIbanLightBox("");
				this.afterRenderApp();
			}
		};
	}

	private getViewConfigForMultiIban(scope: string, callback: () => void): ViewConfiguration<IbanAppDefinition> {
		return {
			data: this.getViewOptions(true, scope),
			templateurl: this.options.app.currenttemplate.templateurl,
			parent: this,
			$ctx: $(`#${scope.replace("-", "")}`),
			options: this.options,
			callback: callback
		};
	}

	private getMultiScopeConfig(): string[] {
		return this.appViewService.getMultiScopeConfig();
	}

	private getViewOptions(hideIntroduction: boolean, scope: string): { [key: string]: any } {
		return {
			HideIntroduction: hideIntroduction,
			Scope: scope,
			Bankdaten: this.appPersistenceService.getBankdatenModelFromStore(scope)
		};
	}

	public afterRenderApp(): void {
		this.loader.loadSubApps({ options: this.options }, () => {
			this.parent.afterRenderApp();
			this.appValidationService = new AppValidationService({ options: this.options }, this.$ctx.find(`#${this.options.contentid}`));
			this.appViewService.addListeners(this);
			if (this.options.app.showpaymentcreditcard && T.Utils.PaymentCreditCard) {
				T.Utils.PaymentCreditCard.loadScripts(this.initPaymentCreditCard.bind(this));
			}
			this.scopes.forEach(scope => {
				const bankdatenModel = this.appPersistenceService.getBankdatenModelFromStore(scope);
				this.appViewService.setBankdatenModelToView(bankdatenModel, scope);
				const field = this.appViewService.getIbanField(scope);
				if (field.length) {
					this.appValidationService.validateIban(
						bankdatenModel,
						() => {
							//NOSONAR
						},
						() => {
							//NOSONAR
						},
						false,
						field[0] as HTMLInputElement);
				}
			});

			if (this.options.app.hideIbanLightbox) {
				this.appViewService.hideIbanLightboxLink();
			}

		});
	}

	public initPaymentCreditCard(): void {
		if (this.options.app.showpaymentcreditcard) {
			this.appApiService.getCreditCardRequestData((data: VerifyHashModelApi) => {
				const request = {
					request: data.Request,
					responsetype: data.ResponseType,
					mode: data.Mode,
					mid: data.MerchantId,
					aid: data.AccountId,
					portalid: data.PortalId,
					encoding: data.Encoding,
					storecarddata: data.StoreCardData,
					hash: data.Hash
				};
				this.getStyleConfig(request);
			}, (jqxhr: JQuery.jqXHR) => {
				AppUtils.Helper.logError(jqxhr, 'IbanCalculator', window.location.href, 'initPaymentCreditCard');
				this.appViewService.hidePaymentCreditCard(true);
			});
		}
	}

	private getStyleConfig(request: { [key: string]: any }): void {
		AppUtils.Ajax.fragment(
			{
				url: this.options.app.creditcardstyleconfig,
				timeout: 30000
			},
			(styleConfig: string) => {
				this.loadIframes(styleConfig, request);
			},
			(jqxhr: JQuery.jqXHR) => {
				AppUtils.Helper.logError(jqxhr, 'IbanCalculator', window.location.href, 'getStyleConfig');
				this.appViewService.hidePaymentCreditCard(true);
			});
	}

	private loadIframes(styleConfig: string, request: { [key: string]: any }): void {
		T.Utils.PaymentCreditCard.loadIframes(styleConfig, request, this.creditCardIframesTimeoutListener.bind(this));
	}

	public creditCardCheckResponseListener(ev: JQuery.Event, data: CreditCardCheckResponseModel): void {
		ev.preventDefault();
		const bankdatenModel = this.appPersistenceService.getBankdatenModelFromStore();
		bankdatenModel.Cardexpiredate = data.cardexpiredate;
		bankdatenModel.Cardtype = data.cardtype;
		bankdatenModel.Pseudocardpan = data.pseudocardpan;
		bankdatenModel.Truncatedcardpan = data.truncatedcardpan;
		bankdatenModel.CreditCardStatus = data.status;
		if (data.status === 'VALID') {
			this.appViewService.toggleCreditCardError(true);
		} else {
			this.appViewService.toggleCreditCardError(false, this.appValidationService.getInvalidCreditCardErrorMessage());
		}
		this.appPersistenceService.setBankdatenModelToStore(bankdatenModel);
		$(window).trigger('creditCardCheckStatus', data.status);
	}

	public creditCardIframesTimeoutListener(ev: JQuery.Event): void {
		if (ev) { ev.preventDefault(); }
		this.appViewService.hidePaymentCreditCard(true);
	}

	public creditCardCheckErrorListener(ev: JQuery.Event): void {
		if (ev) { ev.preventDefault(); }
		this.appViewService.toggleCreditCardError(false, this.appValidationService.getBECreditCardCheckErrorMessage());
		$(window).trigger('creditCardCheckStatus', 'ERROR');
	}

	public viewChangeListener(ev: JQuery.Event): void {
		ev.preventDefault();

		this.scopes.forEach(scope => {
			const bankdatenModel = this.appViewService.getBankdatenModelFromView(scope);
			this.appPersistenceService.setBankdatenModelToStore(bankdatenModel, scope);
		});

		this.$ctx.trigger('ibanupdate');
	}

	public ibanChangeListener(ev: JQuery.Event): void {
		ev.preventDefault();

		this.scopes.forEach(scope => {
			const bankdatenModel = this.appViewService.getBankdatenModelFromView(scope);
			if (bankdatenModel.Iban) {
				if (this.appValidationService.isGermanIban(bankdatenModel.Iban)) {
					this.appViewService.hideBicField(scope);
				} else {
					this.appViewService.showBicField(scope);
				}
			}
		});
	}

	public ibanBlurListener(ev: JQuery.TriggeredEvent): void {
		this.appValidationService.validateIban(undefined, function () {
			// success: nothing to do
		}, function () {
			// failure: handled by appValidationService
		}, true, ev.target as HTMLInputElement);
	}

	public submitListener(ev: JQuery.TriggeredEvent): void {
		ev.preventDefault();
		const scope = this.appViewService.getScopeFromSubmitBtn(ev.currentTarget);
		const scopeFlag = `Kontonummer${scope}`;

		this.appValidationServiceLightbox.setIbanServerValidation(true, scopeFlag);
		if (this.appValidationServiceLightbox.isValid()) {
			const bankdatenModel = this.appPersistenceService.getBankdatenModelFromStore(scope);

			this.appApiService.calculateIban(bankdatenModel, (data: BankOperationReturnConvertApi) => {
				bankdatenModel.Iban = data.Iban;
				bankdatenModel.Bic = data.Bic;
				this.appPersistenceService.setBankdatenModelToStore(bankdatenModel, scope);

				this.appViewService.showAccountFields(scope);
				this.appViewService.setAccountDataToLightbox(data, scope);
			}, () => {
				this.appViewService.hideAccountFields(scope);
				this.appValidationServiceLightbox.setIbanServerValidation(false, scopeFlag);
				this.appValidationServiceLightbox.triggerValidation();
			});
		}
	}

	public lightBoxListener(): void {
		this.appViewService.addFormTagToLightbox();
		this.appViewService.removeValidationTags();
		this.appValidationServiceLightbox = new AppValidationService({ options: this.options }, this.appViewService.getLightboxForm());
		this.appViewService.addLightboxListeners(this);
	}

	public addIbanListener(ev: JQuery.Event): void {
		ev.stopPropagation();
		ev.preventDefault();

		this.scopes.forEach(scope => {
			const bankdatenModel = this.appPersistenceService.getBankdatenModelFromStore(scope);
			this.appViewService.hideAccountFields(scope);
			this.appViewService.closeLighbox();
			this.appViewService.setBankdatenModelToView(bankdatenModel, scope);
		});
	}

	public validateIban(
		successCallback: () => void,
		errorCallback: () => void): void {
		const bankdatenModel = this.appPersistenceService.getBankdatenModelFromStore();
		this.appValidationService.validateIban(bankdatenModel, successCallback, errorCallback);
	}
}